import invariant from 'tiny-invariant'
import { ChainId } from '../constants'
import { validateAndParseAddress } from '../utils'
import { Currency } from './currency'

/**
 * Represents an ERC20 token with a unique address and some metadata.
 */
export class Token extends Currency {
  public readonly chainId: ChainId
  public readonly address: string

  public constructor(chainId: ChainId, address: string, decimals: number, symbol?: string, name?: string) {
    super(decimals, symbol, name)
    this.chainId = chainId
    this.address = validateAndParseAddress(address)
  }

  /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */
  public equals(other: Token): boolean {
    // short circuit on reference equality
    if (this === other) {
      return true
    }
    return this.chainId === other.chainId && this.address === other.address
  }

  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */
  public sortsBefore(other: Token): boolean {
    invariant(this.chainId === other.chainId, 'CHAIN_IDS')
    invariant(this.address !== other.address, 'ADDRESSES')
    return this.address.toLowerCase() < other.address.toLowerCase()
  }
}

/**
 * Compares two currencies for equality
 */
export function currencyEquals(currencyA: Currency, currencyB: Currency): boolean {
  if (currencyA instanceof Token && currencyB instanceof Token) {
    return currencyA.equals(currencyB)
  } else if (currencyA instanceof Token) {
    return false
  } else if (currencyB instanceof Token) {
    return false
  } else {
    return currencyA === currencyB
  }
}

export const WETH = {
  [ChainId.MAINNET]: new Token( ChainId.MAINNET, '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', 18, 'WETH', 'Wrapped Ether' ),
  [ChainId.NOVA]: new Token( ChainId.NOVA, process.env.REACT_APP_WETH as string, 18, 'WETH', 'Wrapped Ether' ),
  [ChainId.KUB]: new Token( ChainId.KUB, process.env.REACT_APP_WETH as string, 18, 'WETH', 'Wrapped Ether' ),
  [ChainId.REI]: new Token( ChainId.REI, process.env.REACT_APP_WETH as string, 18, 'WETH', 'Wrapped Ether' ),  
  [ChainId.IVAR]: new Token( ChainId.IVAR, process.env.REACT_APP_WETH as string, 18, 'WETH', 'Wrapped Ether'),
  [ChainId.TIVAR]: new Token(ChainId.TIVAR, process.env.REACT_APP_WETH as string, 18, 'WETH', 'Wrapped Ether'),
  [ChainId.LOCAL]: new Token(ChainId.LOCAL, process.env.REACT_APP_WETH as string, 18, 'WETH', 'Wrapped Ether')
}
